import { Box, Grid, Typography, useTheme, Stack } from '@mui/material'
import React from 'react'
import location from '../../Assets/Icons/location.svg'
import message from '../../Assets/Icons/message.svg'
import phoneIcon from '../../Assets/Icons/Phone_orage_icon.svg'

const ContactUs = () => {
  const theme = useTheme()

  // Contact information data
  const contactInfo = [
    {
      icon: location,
      alt: 'Location Icon',
      content:
        'Dr. B.R. Ambedkar Institute of Management & Technology, Bagh Lingampally, Hyderabad, Telangana.',
    },
    {
      icon: message,
      alt: 'Email Icon',
      content: 'principal.mba@dbraei.edu.in',
      isLink: true,
      href: 'mailto:principal.mba@dbraei.edu.in',
    },
    {
      icon: phoneIcon,
      alt: 'Phone Icon',
      content: [
        { number: '040 – 2767 06 75', href: 'tel:040-27670675' },
        { number: '9100221282', href: 'tel:+919100221282' },
        { number: '8331041174', href: 'tel:+918331041175' },
      ],
    },
  ]

  return (
    <Box sx={{ maxWidth: 'lg', mx: 'auto', my: 8, px: { xs: 2, md: 4 } }}>
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.text.main,
          fontWeight: 'bold',
          mb: 4,
          textAlign: 'center',
        }}
      >
        Contact Us
      </Typography>

      <Grid container spacing={6}>
        {/* Contact Information Column */}
        <Grid item xs={12} md={6}>
          <Stack spacing={4}>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  color: theme.palette.text.main,
                  fontWeight: 'bold',
                  mb: 2,
                  position: 'relative',
                  display: 'inline-block',
                  '&:after': {
                    content: '""',
                    position: 'absolute',
                    bottom: -8,
                    left: 0,
                    width: 80,
                    height: 4,
                    backgroundColor: theme.palette.secondary.main,
                  },
                }}
              >
                Get In Touch
                <Box
                  sx={{
                    width: 70,
                    height: 4,
                    backgroundColor:
                      theme.palette.background.secondaryBackground,
                    position: 'absolute',
                    bottom: -4,
                    left: 0,
                  }}
                />
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.text.secondary,
                  lineHeight: 1.6,
                }}
              >
                Got something that you would like posted to us? We're all ears!
                Make sure you write in your contact information so we can get
                back to you at the earliest.
              </Typography>
            </Box>

            <Stack spacing={3}>
              {contactInfo.map((item, index) => (
                <Stack
                  key={index}
                  direction="row"
                  spacing={2}
                  alignItems="flex-start"
                >
                  <Box
                    component="img"
                    src={item.icon}
                    alt={item.alt}
                    sx={{
                      width: 24,
                      height: 24,
                      mt: 0.5,
                    }}
                  />
                  <Box>
                    {Array.isArray(item.content) ? (
                      <Stack direction="row" spacing={1} flexWrap="wrap">
                        {item.content.map((phone, i) => (
                          <React.Fragment key={i}>
                            <Typography
                              component="a"
                              href={phone.href}
                              sx={{
                                color: theme.palette.text.primary,
                                textDecoration: 'none',
                                '&:hover': {
                                  textDecoration: 'underline',
                                  color: theme.palette.primary.main,
                                },
                              }}
                            >
                              {phone.number}
                            </Typography>
                            {i < item.content.length - 1 && <span> / </span>}
                          </React.Fragment>
                        ))}
                      </Stack>
                    ) : item.isLink ? (
                      <Typography
                        component="a"
                        href={item.href}
                        sx={{
                          color: theme.palette.text.primary,
                          textDecoration: 'none',
                          '&:hover': {
                            textDecoration: 'underline',
                            color: theme.palette.primary.main,
                          },
                        }}
                      >
                        {item.content}
                      </Typography>
                    ) : (
                      <Typography
                        variant="body1"
                        sx={{ color: theme.palette.text.primary }}
                      >
                        {item.content}
                      </Typography>
                    )}
                  </Box>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Grid>

        {/* Contact Form Column */}
        <Grid item xs={12} md={6}>
          {/* Map Section */}
          <Box sx={{ mt: 4 }}>
            <Typography
              variant="h6"
              sx={{
                color: theme.palette.text.main,
                fontWeight: 'bold',
                mb: 2,
              }}
            >
              Our Location
            </Typography>
            <Box
              component="iframe"
              title="Google Maps Embed"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7614.449523899285!2d78.499843!3d17.400998!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99bf3d11314b%3A0xc93bceef6f9b1a70!2sDr.%20BR%20Ambedkar%20college%2C%20AP%20Housing%20Board%2C%20Bagh%20Lingampally%2C%20New%20Nallakunta%2C%20Hyderabad%2C%20Telangana%20500044!5e0!3m2!1sen!2sin!4v1701691900210!5m2!1sen!2sin"
              sx={{
                width: '100%',
                height: 300,
                border: 0,
                borderRadius: 2,
                boxshadow: theme.shadows[1],
              }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ContactUs
